
import React from 'react';
import { PrayerRequest } from '../types';
import { CloseIcon, NextIcon } from './icons';

interface PrayerTimeViewProps {
  currentPrayer: PrayerRequest;
  onNext: () => void;
  onClose: () => void;
  total: number;
  currentIndex: number;
}

const PrayerTimeView: React.FC<PrayerTimeViewProps> = ({ currentPrayer, onNext, onClose, total, currentIndex }) => {
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl mx-auto p-8 relative flex flex-col h-[90vh] max-h-[700px]">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 dark:text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition">
          <CloseIcon className="w-8 h-8" />
        </button>
        <div className="text-center mb-6">
          <p className="text-sm font-semibold uppercase text-indigo-500 dark:text-indigo-400 tracking-widest">Prayer Time</p>
          <h2 className="text-3xl font-bold mt-1 text-gray-800 dark:text-gray-100">{currentPrayer.title}</h2>
          <p className="text-md text-gray-500 dark:text-gray-400 mt-2">
            For {currentPrayer.requestor} &bull; {new Date(currentPrayer.date).toLocaleDateString()}
          </p>
        </div>
        
        <div className="flex-grow overflow-y-auto p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-600 custom-scrollbar">
          <p className="text-lg leading-relaxed text-gray-700 dark:text-gray-300 whitespace-pre-wrap">{currentPrayer.details}</p>
        </div>

        <div className="mt-6 flex flex-col items-center">
            <p className="text-gray-400 dark:text-gray-500 text-sm mb-4">After praying, say "next prayer" or click the button below.</p>
            <button
                onClick={onNext}
                className="flex items-center gap-2 bg-indigo-600 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-indigo-700 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-indigo-300 dark:focus:ring-indigo-800 transform hover:scale-105"
            >
                Next Prayer ({currentIndex + 1}/{total})
                <NextIcon className="w-5 h-5" />
            </button>
        </div>
      </div>
       <style>{`
          .custom-scrollbar::-webkit-scrollbar {
            width: 8px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f5f9;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
          .dark .custom-scrollbar::-webkit-scrollbar-track {
            background: #374151;
          }
          .dark .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #6b7280;
          }
          .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #9ca3af;
          }
      `}</style>
    </div>
  );
};

export default PrayerTimeView;
